import React from "react";
import { Chart } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  LineController,
  BarElement,
  BarController,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  LineController,
  BarElement,
  BarController,
  Title,
  Tooltip,
  Legend
);

export default function DataGraph({
  incomesData,
  expensesData,
  cashBalanceData,
  potentialBalanceData,
  labels,
  tableHeads,
}) {
  const state = {
    datasets: [
      {
        label: "Cash Balance",
        backgroundColor: "rgba(165,165,165,1)",
        borderColor: "rgb(165,165,165)",
        borderWidth: 2,
        data: cashBalanceData,
        type: "line",
      },
      {
        label: "Potential Balance",
        backgroundColor: "rgba(255,192,0,1)",
        borderColor: "rgb(255,192,0)",
        borderWidth: 2,
        data: potentialBalanceData,
        type: "line",
      },
      {
        label: "Income",
        backgroundColor: "rgba(68,114,196,1)",
        borderColor: "rgb(0,0,0)",
        borderWidth: 2,
        data: incomesData,
        type: "bar",
      },
      {
        label: "Expenses",
        backgroundColor: "rgba(237,125,49,1)",
        borderColor: "rgb(0,0,0)",
        borderWidth: 2,
        data: expensesData,
        type: "bar",
      },
    ],
    labels: labels,
  };

  return (
    <div>
      <Chart
        data={state}
        options={{
          animation: false,
          scales: {
            y: {
              beginAtZero: true,
              ticks: {
                stepSize: 1000,
                callback: function (value) {
                  return "£" + value;
                },
              },
            },
            x: {
              ticks: {
                callback: function (index) {
                  if (index === 0) {
                    return tableHeads.month0;
                  } else if (index === 1) {
                    return tableHeads.month1;
                  } else if (index === 2) {
                    return tableHeads.month2;
                  } else if (index === 3) {
                    return tableHeads.month3;
                  } else if (index === 4) {
                    return tableHeads.month4;
                  } else if (index === 5) {
                    return tableHeads.month5;
                  } else if (index === 6) {
                    return tableHeads.month6;
                  } else if (index === 7) {
                    return tableHeads.month7;
                  } else if (index === 8) {
                    return tableHeads.month8;
                  } else if (index === 9) {
                    return tableHeads.month9;
                  } else if (index === 10) {
                    return tableHeads.month10;
                  } else if (index === 11) {
                    return tableHeads.month11;
                  }
                },
              },
            },
          },
          title: {
            display: true,
            text: "",
            fontSize: 20,
          },
          legend: {
            display: true,
            position: "right",
          },
        }}
      />
    </div>
  );
}
